export default __webpack_public_path__ + "static/media/Overview_V.2.a8bd45e0.jpg";